document.addEventListener('DOMContentLoaded', function(){
  var quiz = document.getElementById('palasQuiz');
  if(!quiz) return;
  var answers = {};
  var screens = quiz.querySelectorAll('.quiz-screen');

  var collections = {
    junior:       { title: 'Palas Junior', emoji:'🧒', desc:'Ligeras y adaptadas para los más jóvenes, fáciles de manejar.', url: '/collections/palas-junior' },
    mujer:        { title: 'Palas para Mujer', emoji:'👩', desc:'Palas más ligeras y manejables, diseñadas para el juego femenino.', url: '/collections/palas-de-mujer' },
    principiante: { title: 'Palas para Principiante', emoji:'🚀', desc:'Máxima tolerancia al error, control y comodidad para aprender.', url: '/collections/palas-para-principiantes' },
    redonda:      { title: 'Forma Redonda', emoji:'🛡️', desc:'Punto dulce amplio y control total. Perfectas para defender y colocar.', url: '/collections/palas-forma-redonda' },
    lagrima:      { title: 'Forma Lágrima', emoji:'⚖️', desc:'El equilibrio perfecto entre control y potencia. La más versátil.', url: '/collections/palas-forma-lagrima' },
    diamante:     { title: 'Forma Diamante', emoji:'💥', desc:'Máxima potencia para rematar. Para jugadores agresivos y con buen nivel.', url: '/collections/palas-forma-diamante' }
  };

  function show(el){ screens.forEach(function(s){ s.classList.remove('is-active'); }); el.classList.add('is-active'); }

  function getResult(){
    if(answers.para === 'junior') return collections.junior;
    if(answers.para === 'mujer') return collections.mujer;
    if(answers.nivel === 'principiante') return collections.principiante;
    if(answers.estilo === 'control') return collections.redonda;
    if(answers.estilo === 'equilibrio') return collections.lagrima;
    if(answers.estilo === 'potencia') return collections.diamante;
    return collections.lagrima;
  }

  var startBtn = quiz.querySelector('[data-quiz-start]');
  if(startBtn) startBtn.addEventListener('click', function(){ show(quiz.querySelector('[data-step="1"]')); });

  quiz.querySelectorAll('.quiz-option').forEach(function(btn){
    btn.addEventListener('click', function(){
      answers[btn.getAttribute('data-q')] = btn.getAttribute('data-value');
      var step = btn.closest('.quiz-step');
      var cur = parseInt(step.getAttribute('data-step'), 10);
      var next = quiz.querySelector('[data-step="'+(cur+1)+'"]');
      if(next){ show(next); }
      else {
        var r = getResult();
        quiz.querySelector('[data-result-emoji]').textContent = r.emoji;
        quiz.querySelector('[data-result-title]').textContent = r.title;
        quiz.querySelector('[data-result-desc]').textContent = r.desc;
        quiz.querySelector('[data-result-link]').setAttribute('href', r.url);
        show(quiz.querySelector('.quiz-result'));
      }
    });
  });

  var restartBtn = quiz.querySelector('[data-quiz-restart]');
  if(restartBtn) restartBtn.addEventListener('click', function(){ answers = {}; show(quiz.querySelector('.quiz-intro')); });
});